module.exports = __webpack_public_path__ + "static/img/inv-5.3acea1a.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/landing/inv-5.png
// module id = JjjL
// module chunks = 0